import type {
  Citation,
  CitationFailureReason,
  PageTextCitation,
} from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/documentSearchApiSchemas'

export type GroupedPageTextCitation = {
  document_id: string
  page_id: string
  page_num: number
  quotes: string[]
  failure_reason: CitationFailureReason | null
}

function citationFailureKey(
  failureReason: PageTextCitation['failure_reason']
): string {
  return failureReason ?? 'ok'
}

export function groupPageTextCitations(
  citations: Citation[]
): GroupedPageTextCitation[] {
  const groups: GroupedPageTextCitation[] = []
  const groupByKey = new Map<string, GroupedPageTextCitation>()

  for (const citation of citations) {
    if (citation.type !== 'page_text') continue
    const failureReason = citation.failure_reason ?? null
    const key = `${citation.document_id}:${citation.page_num}:${citationFailureKey(failureReason)}`
    const existing = groupByKey.get(key)
    if (existing) {
      if (citation.quote && !existing.quotes.includes(citation.quote)) {
        existing.quotes.push(citation.quote)
      }
      continue
    }

    const group: GroupedPageTextCitation = {
      document_id: citation.document_id,
      page_id: citation.page_id,
      page_num: citation.page_num,
      quotes: citation.quote ? [citation.quote] : [],
      failure_reason: failureReason,
    }
    groupByKey.set(key, group)
    groups.push(group)
  }

  return groups
}
